module.exports = __webpack_public_path__ + "assets/getresponse.45d3aaff.svg";